import { RouteType } from "types/RouteType";

export const reconciliationRoute: RouteType = {
  name: "Account Reconciliation",
  path: "/accounting/reconciliation",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Account Reconciliation",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./Reconciliation.Header"),
    },
    body: {
      component: () => import("./Reconciliation.Body"),
      grayBackground: true,
    },
  },
  dialogs: [
    {
      name: "CreateMatchDialog",
      title: "Create Match",
      component: () => import("./dialogs/CreateMatchDialog"),
    },
    {
      name: "ReconciliationCompleteDialog",
      title: "Complete Reconciliation",
      component: () => import("./dialogs/ReconciliationCompleteDialog"),
    },
  ],
  group: "Accounting",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  beforeEnter: async ({ rootStore }) => {
    const store = (rootStore as any).reconciliationStore;
    if (store && typeof store === "object" && "loadData" in store) {
      await store.loadData();
    }
    return true;
  },
  onParamsChange: async ({ rootStore }) => {
    const store = (rootStore as any).reconciliationStore;
    if (store && typeof store === "object" && "loadData" in store) {
      await store.loadData();
    }
  },
};

export default reconciliationRoute;
